
import SnackbarComponent from "@/components/SnackbarComponent.vue";
export default {
  name: "ProfileHeader",
  data(){
    return{
      sidebarVisible: false,
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 3000,
    }
  },
  components: {
    SnackbarComponent
  },
  computed: {
    checkStatus(){
      if (this.$auth.state.user.driver){
        return this.$auth.state.user.driver.can_receive_offers === 1;
      }
    },
    checkUserOrDriver(){
      return this.$auth.state.user.driver;
    },
    sidebarClass() {
      return this.sidebarVisible ? 'sidebar sidebar-open' : 'sidebar';
    },
    driverAvatar(){
      return this.$auth.state.user.driver.avatar? this.$auth.state.user.driver.avatar.url.md: null;
    }
  },
  methods:{
    toggleSidebar() {
      if (this.sidebarVisible === false){
        this.sidebarVisible = true;
      }else{
        this.sidebarVisible = false;
      }
    },
    async logout() {

      await this.$auth.logout();
      this.snackbarMessage = 'خروج موفقیت‌آمیز';
      this.snackbarColor = 'success';
      this.showSnackbar = true;
      if(this.$route.name=='driver'){
        this.$router.push('/driver-index')
      }else{
        this.$router.push('/main-index')
      }
    },
  },
  created() {
    console.log(this.$auth.state.user, 'fffffffffffffffffff')
  }
}
